module.exports = __webpack_public_path__ + "static/media/cocktail2.bd1c9151.svg";